// src/services/groupBusinessService.js
import { domain } from "../auth/domain"; // Assuming domain is defined here

const getAuthHeaders = () => {
  const accessToken = localStorage.getItem("accessToken");
  if (!accessToken) {
    throw new Error("No access token found. Please log in.");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `JWT ${accessToken}`,
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json();
    const errorMessage = errorData.detail || JSON.stringify(errorData);
    throw new Error(errorMessage);
  }
  return response.json();
};

export const fetchGroupBusinesses = async () => {
  const response = await fetch(`${domain}group-businesses/`, {
    method: "GET",
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const createGroupBusiness = async (businessData) => {
  const response = await fetch(`${domain}group-businesses/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(businessData),
  });
  return handleResponse(response);
};

export const approveGroupBusiness = async (businessId, isApprove, rejectionReason = "") => {
  // Used by admin to approve or reject a business registration request
  const response = await fetch(`${domain}group-businesses/${businessId}/approve_business/`, {
    method: "POST", // Or PUT, depending on API design
    headers: getAuthHeaders(),
    body: JSON.stringify({ status: isApprove ? "ACTIVE" : "REJECTED", rejection_reason: rejectionReason }),
  });
  return handleResponse(response);
};



export const fetchBusinessInvoices = async () => {
  const response = await fetch(`${domain}business-invoices/`, {
    method: "GET",
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};


export const createBusinessInvoice = async (invoiceData) => {
  const payload = { ...invoiceData };
  if (payload.base_amount !== undefined && payload.base_amount !== null) {
    payload.base_amount = Number(payload.base_amount);
  }
  const response = await fetch(`${domain}business-invoices/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });
  return handleResponse(response);
};

export const approveBusinessInvoice = async (businessId, invoiceId, action, reason = "") => {
  // action could be "approve" or "reject"
  // The API might expect a status update or a specific action endpoint
  const response = await fetch(`${domain}business-invoices/${invoiceId}/approve_invoice/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ action, reason }),
  });
  return handleResponse(response);
};

export const disburseBusinessInvoice = async (businessId, invoiceId) => {
  const response = await fetch(`${domain}group-businesses/${businessId}/invoices/${invoiceId}/disburse/`, {
    method: "PATCH", // Or PUT
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const downloadBusinessInvoice = async (invoiceId) => {
  const response = await fetch(`${domain}business-invoices/${invoiceId}/download/`, {
    method: "GET",
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};
